import { Routes, Route } from "react-router";
import App from "./pages/App";
import AgroUniao from "./pages/agroUniao";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/agro-uniao" element={<AgroUniao />} />
    </Routes>
  );
}